import {
  customLinks,
  dashboard,
  links,
  qrCodes,
  settings,
  customLinksActive,
  dashboardActive,
  linksActive,
  qrCodesActive,
  settingsActive,
  plus,
  plusActive,
  client1,
  client2,
  client3,
  client4,
  client5,
  client6,
  client7,
  client8,
  client9,
  convert,
  customize,
  qrCodesActiveSecondary,
  glasses,
  connection1,
  connection2,
  connection3,
} from '../../images'

export const MENU_OPTIONS = [
  {
    label: 'WHY_ALTERA',
    to: '/',
    class: 'active-menu',
    section: '#connections',
  },
  { label: 'PRODUCTS', to: '/', class: 'active-menu', section: '#services' },
  { label: 'PRICING', to: '/plans', class: 'active-menu', section: '#plans' },
  { label: 'RESOURCES', to: '/', class: 'active-menu', section: '#benefits' },
]

export const MENU_SETTINGS_OPTIONS = [
  {
    principal_label: 'YOUR_SETTINGS',
    sub_options: [
      { label: 'PROFILE', to: 'PROFILE', class: 'active-menu' },
      { label: 'ACCOUNT_DETAILS', to: 'ACCOUNT_DETAILS', class: 'active-menu' },
    ],
  },

  {
    principal_label: 'ACCOUNT_SETTINGS',
    sub_options: [
      {
        label: 'BILLING_AND_USAGE',
        to: 'BILLING_AND_USAGE',
        class: 'active-menu',
      },
      //  // etapa 2 { label: 'CUSTOM_DOMAINS', to: 'CUSTOM_DOMAINS', class: 'active-menu' },
    ],
  },
]

export const MENU_SIDEBAR_OPTIONS = [
  { label: 'SUPPORT', to: '/', class: 'active-menu' },
  { label: 'API_DOCUMENTATION', to: '/', class: 'active-menu' },
  { label: 'TERMS_AND_CONDITIONS', to: '/', class: 'active-menu' },
]

export const NAVBAR_OPTIONS = [
  {
    item: 'create_new',
    label: 'CREATE_NEW',
    to: '/create-new',
    class: 'active-indicator',
    background: 'active-background',
    img: plus,
    imgActive: plusActive,
  },
  {
    item: 'dashboard',
    label: 'DASHBOARD',
    to: '/dashboard',
    class: 'active-indicator',
    background: 'active-background',
    img: dashboard,
    imgActive: dashboardActive,
  },
  {
    item: 'links',
    label: 'LINKS',
    to: '/links',
    class: 'active-indicator',
    background: 'active-background',
    img: links,
    imgActive: linksActive,
  },
  {
    item: 'QR codes',
    label: 'QR_CODES',
    to: '/qr-codes',
    class: 'active-indicator',
    background: 'active-background',
    img: qrCodes,
    imgActive: qrCodesActive,
  },
  // etapa 2
  // {
  //   item: 'custom links',
  //   label: 'CUSTOM_LINKS',
  //   to: '/custom-links',
  //   class: 'active-indicator',
  //   background: 'active-background',
  //   img: customLinks,
  //   imgActive: customLinksActive,
  // },
  {
    item: 'settings',
    label: 'SETTINGS',
    to: '/settings',
    class: 'active-indicator',
    background: 'active-background',
    img: settings,
    imgActive: settingsActive,
  },
]

export const PLAN_BASIC = [
  { info: 'LINKS_REDIRECT', quantity: '30' },
  { info: 'QR_CODES', quantity: '0' },
  { info: 'LIMITED_ACCESS', quantity: '' },
  { info: 'EMAIL_SUPPORT', quantity: '' },
]

export const PLAN_MEDIUM = [
  { info: 'LINKS_REDIRECT', quantity: '30' },
  { info: 'QR_CODES', quantity: '5' },
  {
    info: 'CUSTOM_LINKS',
    quantity: '',
  },
  { info: 'EMAIL_PRIORITY', quantity: '' },
  {
    info: 'REPORTS',
    quantity: '',
  },
]

export const PLAN_ADVANCED = [
  { info: 'LINKS_REDIRECT', quantity: '100' },
  { info: 'QR_CODES', quantity: '20' },
  { info: 'BRANDED_LINKS', quantity: '' },
  {
    info: 'ACCESS_PLAN',
    quantity: '',
  },
  {
    info: 'SUPPORT_24_7',
    quantity: '',
  },
]

export const SERVICE_URL = [
  { info: 'SHORT_URL_SCALE' },
  { info: 'BRANDED_CUSTOM_LINKS' },
  { info: 'LINKS_REDIRECT' },
  { info: 'ANALISYS_TRACKING' },
]

export const SERVICE_QR = [
  { info: 'QR_CUSTOMIZABLE' },
  { info: 'QR_DYNAMIC' },
  { info: 'QR_TYPES' },
  { info: 'ANALISYS_TRACKING' },
]

export const CLIENTS = [
  client1,
  client2,
  client3,
  client4,
  client5,
  client6,
  client7,
  client8,
  client9,
]

export const BENEFITS = [
  {
    image: convert,
    title: 'CONVERT_LINKS',
    text: 'BENEFITS_INFO_2',
  },
  {
    image: qrCodesActiveSecondary,
    title: 'CREATE_QR_CODE',
    text: 'BENEFITS_INFO_4',
  },
  {
    image: customize,
    title: 'CUSTOM',
    text: 'BENEFITS_INFO_3',
  },
  {
    image: glasses,
    title: 'ANALYZE',
    text: 'BENEFITS_INFO_5',
  },
]

export const CONNECTIONS = [
  {
    image: connection1,
    text: 'ELEVATE_CONECTIONS_INFO_1',
  },
  {
    image: connection2,
    text: 'ELEVATE_CONECTIONS_INFO_2',
  },
  {
    image: connection3,
    text: 'ELEVATE_CONECTIONS_INFO_3',
  },
]
export const cardsOptions = [
  {
    title: 'BASIC',
    plan: 'Basic',
    info_main: '',
    info: PLAN_BASIC,
    priceM: '100',
    priceY: '400',
    active: false,
    color: 'secondary',
    urlM: 'pay?id=5ff1a9fcde1de',
    urlY: 'pay?id=470227f11160e',
  },
  {
    title: 'MEDIUM',
    plan: 'Medium',
    info_main: '',
    info: PLAN_MEDIUM,
    priceM: '200',
    priceY: '500',
    active: false,
    color: 'primary',
    urlM: 'pay?id=6f7a657ae0c75',
    urlY: 'pay?id=359df9ee89c62',
  },

  {
    title: 'ADVANCED',
    plan: 'Advanced',
    info_main: '',
    info: PLAN_ADVANCED,
    priceM: '300',
    priceY: '600',
    active: false,
    color: 'red',
    urlM: 'pay?id=01bac0da3dea0',
    urlY: 'pay?id=40c6e9cea385c',
  },
]
